import { ITotalCartItems } from '@/redux/cart/types';
import { ISeat, IRacket, IProduct } from '@/pages/Cart/types';
import { setCartItemsToStorage } from '@/utils/storage/cartItems';
import store from '@/redux/store';
import { setCartItems } from '@/redux/cart/slice';

type AppDispatch = typeof store.dispatch;

export function updateCartItems(
  cartItems: ITotalCartItems,
  dispatch: AppDispatch
): void {
  setCartItemsToStorage(cartItems);
  dispatch(setCartItems(cartItems));
}

export function removeAttachedRackets(
  cartItems: ITotalCartItems,
  deletedSeat: ISeat
): { updatedCartItems: ITotalCartItems; deletedRackets: { [key: string]: IRacket } } {
  const rackets = cartItems.rackets || {};
  const deletedRackets: { [key: string]: IRacket } = {};

  Object.keys(rackets).forEach((key) => {
    const racket = rackets[key] as IRacket;
    if (
      racket.courtId === deletedSeat.courtId &&
      racket.date === deletedSeat.date &&
      racket.time === deletedSeat.time
    ) {
      deletedRackets[key] = racket;
      delete rackets[key];
    }
  });

  return {
    updatedCartItems: {
      ...cartItems,
      rackets,
    },
    deletedRackets,
  };
}

export function createDeleteItemsPayload(
  deletedSeats: { [key: string]: ISeat } = {},
  deletedRackets: { [key: string]: IRacket } = {},
  deletedProducts: { [key: string]: IProduct } = {}
) {
  return {
    delArr: {
      seats: deletedSeats,
      rackets: deletedRackets,
      products: deletedProducts,
    },
  };
}

export function isItemExpired(
  startTime: Date,
  timeLimitMinutes: number
): boolean {
  const timeLimit = timeLimitMinutes * 60 * 1000;
  const timeDifference = new Date().getTime() - startTime.getTime();
  return timeDifference >= timeLimit;
}

export function getItemStartTime(item: ISeat | IRacket, type: 'seats' | 'rackets'): Date {
  if (type === 'seats') {
    const seat = item as ISeat;
    const startTimeISO = seat.startTimeCourt || `${seat.date}T${seat.time}:00`;
    return new Date(startTimeISO);
  } else {
    const racket = item as IRacket;
    const startTimeISO = racket.startTimeRacket || `${racket.date}T${racket.time}:00`;
    return new Date(startTimeISO);
  }
}
